interface FooterLinkProps {
  data: any
  isSubtitle: boolean
  handleFooterLinks: (sub: any) => void
  className?: string
}

export const FooterLink = ({
  className,
  data,
  isSubtitle,
  handleFooterLinks,
}: FooterLinkProps) => {
  return (
    <li className={`${className} ${isSubtitle ? 'ml-0' : 'ml-2 lg:ml-0'} mb-2`}>
      <a
        onClick={!isSubtitle ? () => handleFooterLinks(data) : undefined}
        className={`${isSubtitle
          ? 'text-[#83a7d7]'
          : 'cursor-pointer text-[#BBC7D7] text-base'
          }`}
      >
        {data.name}
      </a>
    </li>
  )
}
